import { render, staticRenderFns } from "./DDWelcome.vue?vue&type=template&id=b7cec19a&"
import script from "./DDWelcome.vue?vue&type=script&lang=js&"
export * from "./DDWelcome.vue?vue&type=script&lang=js&"
import style0 from "./DDWelcome.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports